var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertify-position"},[_c('canvas',{ref:"canvas",on:{"click":function($event){return _vm.createCode()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }